import { THEMES } from '../Data/themes';
import { ThemeDefinition } from '../Data/types';

export function getThemeForDate(date: Date): ThemeDefinition {
  const dayOfYear = getDayOfYear(date);
  return THEMES[dayOfYear % THEMES.length];
}

function getDayOfYear(date: Date): number {
  const start = new Date(date.getFullYear(), 0, 0);
  const diff = date.getTime() - start.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

export function getCraftegoryLevelId(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `craftegory-${y}-${m}-${d}`;
}
